import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { VinCheckerInfoGQL } from '../../../../../graphql/service/graphql-auto-main-service';
import { map } from 'rxjs/operators';
import { QueryHandlingService } from '@akebono/core';
import { Observable } from 'rxjs';
import { DateTime } from 'luxon';
import { CheckProductionDatesInfoVinSupportDataType } from './types/check-production-dates-info-vin-support-data.type';

@Component({
  selector: 'app-check-production-dates-info',
  templateUrl: './check-production-dates-info.component.html',
  styleUrls: ['./check-production-dates-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckProductionDatesInfoComponent implements OnInit {
  vinSupportData$: Observable<CheckProductionDatesInfoVinSupportDataType[]>;
  loading$: Observable<boolean>;

  constructor(private qhs: QueryHandlingService, private vinCheckerInfoGQL: VinCheckerInfoGQL) {}

  ngOnInit(): void {
    const queryRef = this.qhs.fetch(this.vinCheckerInfoGQL);
    this.loading$ = queryRef.loading;
    this.vinSupportData$ = queryRef.data.pipe(
      map(
        (result) =>
          result?.vincheckerInfo?.map((info) => ({
            manufacturer: info.maker,
            range: `${this.formatDate(info.rangeStartDate)}-${this.formatDate(info.rangeEndDate)}`,
            model: info.chassisId,
            digits: +info.necessaryDigitInBodyNumber,
          })) ?? [],
      ),
    );
  }

  private formatDate(dateStr: string): string {
    const dt = DateTime.fromISO(dateStr);
    return dt.isValid ? dt.toFormat('MM.yyyy') : '';
  }
}
